const SESSION_KEY = 'thoth_remote_override';
const QUERY_PARAM = 'thoth_remote';
const VALID_OVERRIDE = /^pr-\d+$/;

export function isThothOverrideAllowed(): boolean {
  return ['true'].includes(process.env.REACT_APP_ALLOW_THOTH_OVERRIDE);
}

/**
 * The active ephemeral Thoth environment for this session, or null when there is none.
 */
export function getThothOverride(): string | null {
  if (!isThothOverrideAllowed()) {
    return null;
  }

  const override = sessionStorage.getItem(SESSION_KEY);
  return override && VALID_OVERRIDE.test(override) ? override : null;
}

/**
 * Persists a valid `?thoth_remote=pr-42` query parameter for the rest of the browser session.
 */
export function storeThothOverrideFromUrl(): void {
  if (!isThothOverrideAllowed()) {
    return;
  }

  const param = new URLSearchParams(window.location.search).get(QUERY_PARAM);
  if (param && VALID_OVERRIDE.test(param)) {
    sessionStorage.setItem(SESSION_KEY, param);
  }
}
